import { colors } from "../config/color";
import { useQuery } from "./use-query";

export const whiteList = ["color", "pattern", "texture", "line-silhouette"];

export const useType = () => {
  const query = useQuery();
  const type = query.get("type");

  return type
    ? whiteList.includes(type)
      ? (type as keyof typeof colors)
      : undefined
    : undefined;
};
